export const localesByContinents: Record<string, Record<string, string>> = {
  Africa: {
    AO: 'Angola',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    BJ: 'Benin',
    BW: 'Botswana',
    CD: 'Democratic Republic of the Congo',
    CF: 'Central African Republic',
    CG: 'Republic of the Congo',
    CI: 'Ivory Coast',
    CM: 'Cameroon',
    CV: 'Cabo Verde',
    DJ: 'Djibouti',
    DZ: 'Algeria',
    EG: 'Egypt',
    EH: 'Western Sahara',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    GA: 'Gabon',
    GH: 'Ghana',
    GM: 'Gambia',
    GN: 'Guinea',
    GQ: 'Equatorial Guinea',
    GW: 'Guinea-Bissau',
    KE: 'Kenya',
    KM: 'Comoros',
    LR: 'Liberia',
    LS: 'Lesotho',
    LY: 'Libya',
    MA: 'Morocco',
    MG: 'Madagascar',
    ML: 'Mali',
    MR: 'Mauritania',
    MU: 'Mauritius',
    MW: 'Malawi',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NE: 'Niger',
    NG: 'Nigeria',
    RE: 'Reunion',
    RW: 'Rwanda',
    SC: 'Seychelles',
    SD: 'Sudan',
    SS: 'South Sudan',
    SH: 'Saint Helena',
    SL: 'Sierra Leone',
    SN: 'Senegal',
    SO: 'Somalia',
    ST: 'Sao Tome and Principe',
    SZ: 'Eswatini',
    TD: 'Chad',
    TG: 'Togo',
    TN: 'Tunisia',
    TZ: 'Tanzania',
    UG: 'Uganda',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
  Antarctica: {
    AQ: 'Antarctica',
    BV: 'Bouvet Island',
    GS: 'South Georgia and the South Sandwich Islands',
    HM: 'Heard Island and McDonald Islands',
    TF: 'French Southern Territories',
  },
  Asia: {
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AM: 'Armenia',
    AZ: 'Azerbaijan',
    BD: 'Bangladesh',
    BH: 'Bahrain',
    BN: 'Brunei',
    BT: 'Bhutan',
    CC: 'Cocos Islands',
    CN: 'China',
    GE: 'Georgia',
    HK: 'Hong Kong',
    ID: 'Indonesia',
    IL: 'Israel',
    IN: 'India',
    IO: 'British Indian Ocean Territory',
    IQ: 'Iraq',
    IR: 'Iran',
    JO: 'Jordan',
    JP: 'Japan',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LK: 'Sri Lanka',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macao',
    MV: 'Maldives',
    MY: 'Malaysia',
    NP: 'Nepal',
    OM: 'Oman',
    PH: 'Philippines',
    PK: 'Pakistan',
    PS: 'Palestinian Territory',
    QA: 'Qatar',
    SA: 'Saudi Arabia',
    SG: 'Singapore',
    SY: 'Syria',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TM: 'Turkmenistan',
    TR: 'Turkey',
    TW: 'Taiwan',
    UZ: 'Uzbekistan',
    VN: 'Vietnam',
    YE: 'Yemen',
  },
  Europe: {
    AD: 'Andorra',
    AL: 'Albania',
    AT: 'Austria',
    AX: 'Aland Islands',
    BA: 'Bosnia and Herzegovina',
    BE: 'Belgium',
    BG: 'Bulgaria',
    BY: 'Belarus',
    CH: 'Switzerland',
    CY: 'Cyprus',
    CZ: 'Czechia',
    DE: 'Germany',
    DK: 'Denmark',
    EE: 'Estonia',
    ES: 'Spain',
    FI: 'Finland',
    FO: 'Faroe Islands',
    FR: 'France',
    GB: 'United Kingdom',
    GG: 'Guernsey',
    GI: 'Gibraltar',
    GR: 'Greece',
    HR: 'Croatia',
    HU: 'Hungary',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IS: 'Iceland',
    IT: 'Italy',
    JE: 'Jersey',
    XK: 'Kosovo',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MK: 'North Macedonia',
    MT: 'Malta',
    NL: 'Netherlands',
    NO: 'Norway',
    PL: 'Poland',
    PT: 'Portugal',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russia',
    SE: 'Sweden',
    SI: 'Slovenia',
    SJ: 'Svalbard and Jan Mayen',
    SK: 'Slovakia',
    SM: 'San Marino',
    UA: 'Ukraine',
    VA: 'Vatican',
    CS: 'Serbia and Montenegro',
  },
  'North America': {
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AW: 'Aruba',
    BB: 'Barbados',
    BL: 'Saint Barthelemy',
    BM: 'Bermuda',
    BQ: 'Bonaire, Saint Eustatius and Saba',
    BS: 'Bahamas',
    BZ: 'Belize',
    CA: 'Canada',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CW: 'Curacao',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    GD: 'Grenada',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GT: 'Guatemala',
    HN: 'Honduras',
    HT: 'Haiti',
    JM: 'Jamaica',
    KN: 'Saint Kitts and Nevis',
    KY: 'Cayman Islands',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    MQ: 'Martinique',
    MS: 'Montserrat',
    MX: 'Mexico',
    NI: 'Nicaragua',
    PA: 'Panama',
    PM: 'Saint Pierre and Miquelon',
    PR: 'Puerto Rico',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    TC: 'Turks and Caicos Islands',
    TT: 'Trinidad and Tobago',
    US: 'United States',
    VC: 'Saint Vincent and the Grenadines',
    VG: 'British Virgin Islands',
    VI: 'U.S. Virgin Islands',
    AN: 'Netherlands Antilles',
  },
  Oceania: {
    AS: 'American Samoa',
    AU: 'Australia',
    CK: 'Cook Islands',
    CX: 'Christmas Island',
    FJ: 'Fiji',
    FM: 'Micronesia',
    GU: 'Guam',
    KI: 'Kiribati',
    MH: 'Marshall Islands',
    MP: 'Northern Mariana Islands',
    NC: 'New Caledonia',
    NF: 'Norfolk Island',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PN: 'Pitcairn',
    PW: 'Palau',
    SB: 'Solomon Islands',
    TK: 'Tokelau',
    TL: 'Timor Leste',
    TO: 'Tonga',
    TV: 'Tuvalu',
    UM: 'United States Minor Outlying Islands',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    WS: 'Samoa',
  },
  'South America': {
    AR: 'Argentina',
    BO: 'Bolivia',
    BR: 'Brazil',
    CL: 'Chile',
    CO: 'Colombia',
    EC: 'Ecuador',
    FK: 'Falkland Islands',
    GF: 'French Guiana',
    GY: 'Guyana',
    PE: 'Peru',
    PY: 'Paraguay',
    SR: 'Suriname',
    UY: 'Uruguay',
    VE: 'Venezuela',
  },
};

export const continents = Object.keys(localesByContinents);

export const UNKNOWN_CONTINENT_VALUE = 'Other';

export const continentOrderPriority = {
  ...continents.reduce((sortingPriority, currentContinent, index) => {
    return {
      ...sortingPriority,
      [currentContinent]: index,
    };
  }, {}),
  [UNKNOWN_CONTINENT_VALUE]: Infinity,
};
